package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * South Korea Flag (16x12dp)
 *
 * - ISO Alpha-2: KR
 * - ISO Alpha-3: KOR
 * - ISO Numeric: 410
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.SouthKorea: ImageVector by lazy {
    ImageVector.Builder(
        name = "South Korea:KR:KOR:410:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFF3D58DB)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.893f, 9.286f)
                curveTo(9.601f, 9.286f, 10.986f, 7.868f, 10.986f, 6.118f)
                curveTo(10.986f, 4.369f, 9.601f, 2.951f, 7.893f, 2.951f)
                curveTo(6.185f, 2.951f, 4.8f, 4.369f, 4.8f, 6.118f)
                curveTo(4.8f, 7.868f, 6.185f, 9.286f, 7.893f, 9.286f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(7.893f, 9.286f)
                curveTo(9.601f, 9.286f, 10.986f, 7.868f, 10.986f, 6.118f)
                curveTo(10.986f, 4.369f, 9.601f, 2.951f, 7.893f, 2.951f)
                curveTo(6.185f, 2.951f, 4.8f, 4.369f, 4.8f, 6.118f)
                curveTo(4.8f, 7.868f, 6.185f, 9.286f, 7.893f, 9.286f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFFE31D1C)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.094f, 6.361f)
                curveTo(11.094f, 6.361f, 10.921f, 4.868f, 9.635f, 4.787f)
                curveTo(8.349f, 4.705f, 8.003f, 5.882f, 7.928f, 6.193f)
                curveTo(7.854f, 6.505f, 7.667f, 7.336f, 6.313f, 7.336f)
                curveTo(4.959f, 7.336f, 4.837f, 5.222f, 4.837f, 5.222f)
                verticalLineTo(2.73f)
                horizontalLineTo(11.094f)
                verticalLineTo(6.361f)
                close()
            }
        }
        path(
            fill = SolidColor(Color(0xFF272727)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.65f, 1.026f)
            lineTo(4.107f, 1.44f)
            lineTo(1.987f, 3.916f)
            lineTo(1.53f, 3.502f)
            lineTo(3.65f, 1.026f)
            close()
            moveTo(4.404f, 1.696f)
            lineTo(4.862f, 2.109f)
            lineTo(2.818f, 4.55f)
            lineTo(2.36f, 4.136f)
            lineTo(4.404f, 1.696f)
            close()
            moveTo(5.613f, 2.787f)
            lineTo(5.155f, 2.373f)
            lineTo(3.105f, 4.832f)
            lineTo(3.563f, 5.246f)
            lineTo(5.613f, 2.787f)
            close()
        }
        path(fill = SolidColor(Color(0xFF272727))) {
            moveTo(4.107f, 1.44f)
            lineTo(4.164f, 1.489f)
            lineTo(4.212f, 1.433f)
            lineTo(4.157f, 1.384f)
            lineTo(4.107f, 1.44f)
            close()
            moveTo(3.65f, 1.026f)
            lineTo(3.7f, 0.97f)
            lineTo(3.643f, 0.919f)
            lineTo(3.593f, 0.977f)
            lineTo(3.65f, 1.026f)
            close()
            moveTo(1.987f, 3.916f)
            lineTo(1.937f, 3.971f)
            lineTo(1.994f, 4.023f)
            lineTo(2.044f, 3.965f)
            lineTo(1.987f, 3.916f)
            close()
            moveTo(1.53f, 3.502f)
            lineTo(1.473f, 3.453f)
            lineTo(1.425f, 3.509f)
            lineTo(1.479f, 3.558f)
            lineTo(1.53f, 3.502f)
            close()
            moveTo(4.862f, 2.109f)
            lineTo(4.919f, 2.158f)
            lineTo(4.966f, 2.102f)
            lineTo(4.912f, 2.054f)
            lineTo(4.862f, 2.109f)
            close()
            moveTo(4.404f, 1.696f)
            lineTo(4.454f, 1.64f)
            lineTo(4.397f, 1.588f)
            lineTo(4.347f, 1.648f)
            lineTo(4.404f, 1.696f)
            close()
            moveTo(2.818f, 4.55f)
            lineTo(2.767f, 4.605f)
            lineTo(2.825f, 4.657f)
            lineTo(2.875f, 4.598f)
            lineTo(2.818f, 4.55f)
            close()
            moveTo(2.36f, 4.136f)
            lineTo(2.303f, 4.088f)
            lineTo(2.256f, 4.143f)
            lineTo(2.31f, 4.191f)
            lineTo(2.36f, 4.136f)
            close()
            moveTo(5.155f, 2.373f)
            lineTo(5.206f, 2.318f)
            lineTo(5.148f, 2.265f)
            lineTo(5.098f, 2.325f)
            lineTo(5.155f, 2.373f)
            close()
            moveTo(5.613f, 2.787f)
            lineTo(5.67f, 2.835f)
            lineTo(5.716f, 2.78f)
            lineTo(5.663f, 2.732f)
            lineTo(5.613f, 2.787f)
            close()
            moveTo(3.105f, 4.832f)
            lineTo(3.048f, 4.784f)
            lineTo(3.002f, 4.839f)
            lineTo(3.055f, 4.888f)
            lineTo(3.105f, 4.832f)
            close()
            moveTo(3.563f, 5.246f)
            lineTo(3.513f, 5.301f)
            lineTo(3.57f, 5.354f)
            lineTo(3.62f, 5.294f)
            lineTo(3.563f, 5.246f)
            close()
            moveTo(4.157f, 1.384f)
            lineTo(3.7f, 0.97f)
            lineTo(3.599f, 1.082f)
            lineTo(4.057f, 1.495f)
            lineTo(4.157f, 1.384f)
            close()
            moveTo(2.044f, 3.965f)
            lineTo(4.164f, 1.489f)
            lineTo(4.05f, 1.391f)
            lineTo(1.93f, 3.867f)
            lineTo(2.044f, 3.965f)
            close()
            moveTo(1.479f, 3.558f)
            lineTo(1.937f, 3.971f)
            lineTo(2.037f, 3.86f)
            lineTo(1.58f, 3.446f)
            lineTo(1.479f, 3.558f)
            close()
            moveTo(3.593f, 0.977f)
            lineTo(1.473f, 3.453f)
            lineTo(1.587f, 3.551f)
            lineTo(3.707f, 1.075f)
            lineTo(3.593f, 0.977f)
            close()
            moveTo(4.912f, 2.054f)
            lineTo(4.454f, 1.64f)
            lineTo(4.354f, 1.751f)
            lineTo(4.811f, 2.165f)
            lineTo(4.912f, 2.054f)
            close()
            moveTo(2.875f, 4.598f)
            lineTo(4.919f, 2.158f)
            lineTo(4.804f, 2.061f)
            lineTo(2.76f, 4.501f)
            lineTo(2.875f, 4.598f)
            close()
            moveTo(2.31f, 4.191f)
            lineTo(2.767f, 4.605f)
            lineTo(2.868f, 4.494f)
            lineTo(2.41f, 4.08f)
            lineTo(2.31f, 4.191f)
            close()
            moveTo(4.347f, 1.648f)
            lineTo(2.303f, 4.088f)
            lineTo(2.418f, 4.184f)
            lineTo(4.462f, 1.744f)
            lineTo(4.347f, 1.648f)
            close()
            moveTo(5.105f, 2.429f)
            lineTo(5.562f, 2.843f)
            lineTo(5.663f, 2.732f)
            lineTo(5.206f, 2.318f)
            lineTo(5.105f, 2.429f)
            close()
            moveTo(3.163f, 4.88f)
            lineTo(5.213f, 2.422f)
            lineTo(5.098f, 2.325f)
            lineTo(3.048f, 4.784f)
            lineTo(3.163f, 4.88f)
            close()
            moveTo(3.613f, 5.19f)
            lineTo(3.156f, 4.776f)
            lineTo(3.055f, 4.888f)
            lineTo(3.513f, 5.301f)
            lineTo(3.613f, 5.19f)
            close()
            moveTo(5.555f, 2.739f)
            lineTo(3.505f, 5.198f)
            lineTo(3.62f, 5.294f)
            lineTo(5.67f, 2.835f)
            lineTo(5.555f, 2.739f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF272727)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(12.292f, 1.026f)
            lineTo(11.835f, 1.44f)
            lineTo(13.955f, 3.916f)
            lineTo(14.413f, 3.502f)
            lineTo(12.292f, 1.026f)
            close()
            moveTo(11.538f, 1.696f)
            lineTo(11.081f, 2.109f)
            lineTo(13.125f, 4.55f)
            lineTo(13.582f, 4.136f)
            lineTo(11.538f, 1.696f)
            close()
            moveTo(10.33f, 2.787f)
            lineTo(10.787f, 2.373f)
            lineTo(12.837f, 4.832f)
            lineTo(12.379f, 5.246f)
            lineTo(10.33f, 2.787f)
            close()
        }
        path(fill = SolidColor(Color(0xFF272727))) {
            moveTo(11.835f, 1.44f)
            lineTo(11.778f, 1.489f)
            lineTo(11.731f, 1.433f)
            lineTo(11.785f, 1.384f)
            lineTo(11.835f, 1.44f)
            close()
            moveTo(12.292f, 1.026f)
            lineTo(12.242f, 0.97f)
            lineTo(12.299f, 0.919f)
            lineTo(12.349f, 0.977f)
            lineTo(12.292f, 1.026f)
            close()
            moveTo(13.955f, 3.916f)
            lineTo(14.005f, 3.971f)
            lineTo(13.948f, 4.023f)
            lineTo(13.898f, 3.965f)
            lineTo(13.955f, 3.916f)
            close()
            moveTo(14.413f, 3.502f)
            lineTo(14.47f, 3.453f)
            lineTo(14.517f, 3.509f)
            lineTo(14.463f, 3.558f)
            lineTo(14.413f, 3.502f)
            close()
            moveTo(11.081f, 2.109f)
            lineTo(11.023f, 2.158f)
            lineTo(10.977f, 2.102f)
            lineTo(11.03f, 2.054f)
            lineTo(11.081f, 2.109f)
            close()
            moveTo(11.538f, 1.696f)
            lineTo(11.488f, 1.64f)
            lineTo(11.545f, 1.588f)
            lineTo(11.595f, 1.648f)
            lineTo(11.538f, 1.696f)
            close()
            moveTo(13.125f, 4.55f)
            lineTo(13.175f, 4.605f)
            lineTo(13.117f, 4.657f)
            lineTo(13.067f, 4.598f)
            lineTo(13.125f, 4.55f)
            close()
            moveTo(13.582f, 4.136f)
            lineTo(13.64f, 4.088f)
            lineTo(13.686f, 4.143f)
            lineTo(13.632f, 4.191f)
            lineTo(13.582f, 4.136f)
            close()
            moveTo(10.787f, 2.373f)
            lineTo(10.737f, 2.318f)
            lineTo(10.795f, 2.265f)
            lineTo(10.845f, 2.325f)
            lineTo(10.787f, 2.373f)
            close()
            moveTo(10.33f, 2.787f)
            lineTo(10.272f, 2.835f)
            lineTo(10.226f, 2.78f)
            lineTo(10.279f, 2.732f)
            lineTo(10.33f, 2.787f)
            close()
            moveTo(12.837f, 4.832f)
            lineTo(12.894f, 4.784f)
            lineTo(12.941f, 4.839f)
            lineTo(12.887f, 4.888f)
            lineTo(12.837f, 4.832f)
            close()
            moveTo(12.379f, 5.246f)
            lineTo(12.43f, 5.301f)
            lineTo(12.372f, 5.354f)
            lineTo(12.322f, 5.294f)
            lineTo(12.379f, 5.246f)
            close()
            moveTo(11.785f, 1.384f)
            lineTo(12.242f, 0.97f)
            lineTo(12.343f, 1.082f)
            lineTo(11.885f, 1.495f)
            lineTo(11.785f, 1.384f)
            close()
            moveTo(13.898f, 3.965f)
            lineTo(11.778f, 1.489f)
            lineTo(11.892f, 1.391f)
            lineTo(14.012f, 3.867f)
            lineTo(13.898f, 3.965f)
            close()
            moveTo(14.463f, 3.558f)
            lineTo(14.005f, 3.971f)
            lineTo(13.905f, 3.86f)
            lineTo(14.362f, 3.446f)
            lineTo(14.463f, 3.558f)
            close()
            moveTo(12.349f, 0.977f)
            lineTo(14.47f, 3.453f)
            lineTo(14.356f, 3.551f)
            lineTo(12.236f, 1.075f)
            lineTo(12.349f, 0.977f)
            close()
            moveTo(11.03f, 2.054f)
            lineTo(11.488f, 1.64f)
            lineTo(11.588f, 1.751f)
            lineTo(11.131f, 2.165f)
            lineTo(11.03f, 2.054f)
            close()
            moveTo(13.067f, 4.598f)
            lineTo(11.023f, 2.158f)
            lineTo(11.138f, 2.061f)
            lineTo(13.182f, 4.501f)
            lineTo(13.067f, 4.598f)
            close()
            moveTo(13.632f, 4.191f)
            lineTo(13.175f, 4.605f)
            lineTo(13.074f, 4.494f)
            lineTo(13.532f, 4.08f)
            lineTo(13.632f, 4.191f)
            close()
            moveTo(11.595f, 1.648f)
            lineTo(13.64f, 4.088f)
            lineTo(13.525f, 4.184f)
            lineTo(11.481f, 1.744f)
            lineTo(11.595f, 1.648f)
            close()
            moveTo(10.837f, 2.429f)
            lineTo(10.38f, 2.843f)
            lineTo(10.279f, 2.732f)
            lineTo(10.737f, 2.318f)
            lineTo(10.837f, 2.429f)
            close()
            moveTo(12.779f, 4.88f)
            lineTo(10.729f, 2.422f)
            lineTo(10.845f, 2.325f)
            lineTo(12.894f, 4.784f)
            lineTo(12.779f, 4.88f)
            close()
            moveTo(12.329f, 5.19f)
            lineTo(12.786f, 4.776f)
            lineTo(12.887f, 4.888f)
            lineTo(12.43f, 5.301f)
            lineTo(12.329f, 5.19f)
            close()
            moveTo(10.387f, 2.739f)
            lineTo(12.437f, 5.198f)
            lineTo(12.322f, 5.294f)
            lineTo(10.272f, 2.835f)
            lineTo(10.387f, 2.739f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF272727)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(3.65f, 11.246f)
            lineTo(4.107f, 10.832f)
            lineTo(1.987f, 8.356f)
            lineTo(1.53f, 8.77f)
            lineTo(3.65f, 11.246f)
            close()
            moveTo(4.404f, 10.576f)
            lineTo(4.862f, 10.163f)
            lineTo(2.818f, 7.722f)
            lineTo(2.36f, 8.136f)
            lineTo(4.404f, 10.576f)
            close()
            moveTo(5.613f, 9.485f)
            lineTo(5.155f, 9.898f)
            lineTo(3.105f, 7.44f)
            lineTo(3.563f, 7.026f)
            lineTo(5.613f, 9.485f)
            close()
        }
        path(fill = SolidColor(Color(0xFF272727))) {
            moveTo(4.107f, 10.832f)
            lineTo(4.164f, 10.783f)
            lineTo(4.212f, 10.839f)
            lineTo(4.157f, 10.888f)
            lineTo(4.107f, 10.832f)
            close()
            moveTo(3.65f, 11.246f)
            lineTo(3.7f, 11.302f)
            lineTo(3.643f, 11.353f)
            lineTo(3.593f, 11.295f)
            lineTo(3.65f, 11.246f)
            close()
            moveTo(1.987f, 8.356f)
            lineTo(1.937f, 8.301f)
            lineTo(1.994f, 8.249f)
            lineTo(2.044f, 8.307f)
            lineTo(1.987f, 8.356f)
            close()
            moveTo(1.53f, 8.77f)
            lineTo(1.473f, 8.819f)
            lineTo(1.425f, 8.763f)
            lineTo(1.479f, 8.714f)
            lineTo(1.53f, 8.77f)
            close()
            moveTo(4.862f, 10.163f)
            lineTo(4.919f, 10.114f)
            lineTo(4.966f, 10.17f)
            lineTo(4.912f, 10.218f)
            lineTo(4.862f, 10.163f)
            close()
            moveTo(4.404f, 10.576f)
            lineTo(4.454f, 10.632f)
            lineTo(4.397f, 10.684f)
            lineTo(4.347f, 10.624f)
            lineTo(4.404f, 10.576f)
            close()
            moveTo(2.818f, 7.722f)
            lineTo(2.767f, 7.667f)
            lineTo(2.825f, 7.615f)
            lineTo(2.875f, 7.674f)
            lineTo(2.818f, 7.722f)
            close()
            moveTo(2.36f, 8.136f)
            lineTo(2.303f, 8.184f)
            lineTo(2.256f, 8.129f)
            lineTo(2.31f, 8.081f)
            lineTo(2.36f, 8.136f)
            close()
            moveTo(5.155f, 9.898f)
            lineTo(5.206f, 9.954f)
            lineTo(5.148f, 10.007f)
            lineTo(5.098f, 9.946f)
            lineTo(5.155f, 9.898f)
            close()
            moveTo(5.613f, 9.485f)
            lineTo(5.67f, 9.437f)
            lineTo(5.716f, 9.492f)
            lineTo(5.663f, 9.54f)
            lineTo(5.613f, 9.485f)
            close()
            moveTo(3.105f, 7.44f)
            lineTo(3.048f, 7.488f)
            lineTo(3.002f, 7.433f)
            lineTo(3.055f, 7.384f)
            lineTo(3.105f, 7.44f)
            close()
            moveTo(3.563f, 7.026f)
            lineTo(3.513f, 6.97f)
            lineTo(3.57f, 6.918f)
            lineTo(3.62f, 6.978f)
            lineTo(3.563f, 7.026f)
            close()
            moveTo(4.157f, 10.888f)
            lineTo(3.7f, 11.302f)
            lineTo(3.599f, 11.19f)
            lineTo(4.057f, 10.776f)
            lineTo(4.157f, 10.888f)
            close()
            moveTo(2.044f, 8.307f)
            lineTo(4.164f, 10.783f)
            lineTo(4.05f, 10.881f)
            lineTo(1.93f, 8.405f)
            lineTo(2.044f, 8.307f)
            close()
            moveTo(1.479f, 8.714f)
            lineTo(1.937f, 8.301f)
            lineTo(2.037f, 8.412f)
            lineTo(1.58f, 8.826f)
            lineTo(1.479f, 8.714f)
            close()
            moveTo(3.593f, 11.295f)
            lineTo(1.473f, 8.819f)
            lineTo(1.587f, 8.721f)
            lineTo(3.707f, 11.197f)
            lineTo(3.593f, 11.295f)
            close()
            moveTo(4.912f, 10.218f)
            lineTo(4.454f, 10.632f)
            lineTo(4.354f, 10.521f)
            lineTo(4.811f, 10.107f)
            lineTo(4.912f, 10.218f)
            close()
            moveTo(2.875f, 7.674f)
            lineTo(4.919f, 10.114f)
            lineTo(4.804f, 10.211f)
            lineTo(2.76f, 7.771f)
            lineTo(2.875f, 7.674f)
            close()
            moveTo(2.31f, 8.081f)
            lineTo(2.767f, 7.667f)
            lineTo(2.868f, 7.778f)
            lineTo(2.41f, 8.192f)
            lineTo(2.31f, 8.081f)
            close()
            moveTo(4.347f, 10.624f)
            lineTo(2.303f, 8.184f)
            lineTo(2.418f, 8.088f)
            lineTo(4.462f, 10.528f)
            lineTo(4.347f, 10.624f)
            close()
            moveTo(5.105f, 9.843f)
            lineTo(5.562f, 9.429f)
            lineTo(5.663f, 9.54f)
            lineTo(5.206f, 9.954f)
            lineTo(5.105f, 9.843f)
            close()
            moveTo(3.163f, 7.392f)
            lineTo(5.213f, 9.85f)
            lineTo(5.098f, 9.946f)
            lineTo(3.048f, 7.488f)
            lineTo(3.163f, 7.392f)
            close()
            moveTo(3.613f, 7.082f)
            lineTo(3.156f, 7.495f)
            lineTo(3.055f, 7.384f)
            lineTo(3.513f, 6.97f)
            lineTo(3.613f, 7.082f)
            close()
            moveTo(5.555f, 9.533f)
            lineTo(3.505f, 7.074f)
            lineTo(3.62f, 6.978f)
            lineTo(5.67f, 9.437f)
            lineTo(5.555f, 9.533f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF272727)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(12.292f, 11.246f)
            lineTo(11.835f, 10.832f)
            lineTo(13.955f, 8.356f)
            lineTo(14.413f, 8.77f)
            lineTo(12.292f, 11.246f)
            close()
            moveTo(11.538f, 10.576f)
            lineTo(11.081f, 10.163f)
            lineTo(13.125f, 7.722f)
            lineTo(13.582f, 8.136f)
            lineTo(11.538f, 10.576f)
            close()
            moveTo(10.33f, 9.485f)
            lineTo(10.787f, 9.898f)
            lineTo(12.837f, 7.44f)
            lineTo(12.379f, 7.026f)
            lineTo(10.33f, 9.485f)
            close()
        }
        path(fill = SolidColor(Color(0xFF272727))) {
            moveTo(11.835f, 10.832f)
            lineTo(11.778f, 10.783f)
            lineTo(11.731f, 10.839f)
            lineTo(11.785f, 10.888f)
            lineTo(11.835f, 10.832f)
            close()
            moveTo(12.292f, 11.246f)
            lineTo(12.242f, 11.302f)
            lineTo(12.299f, 11.353f)
            lineTo(12.349f, 11.295f)
            lineTo(12.292f, 11.246f)
            close()
            moveTo(13.955f, 8.356f)
            lineTo(14.005f, 8.301f)
            lineTo(13.948f, 8.249f)
            lineTo(13.898f, 8.307f)
            lineTo(13.955f, 8.356f)
            close()
            moveTo(14.413f, 8.77f)
            lineTo(14.47f, 8.819f)
            lineTo(14.517f, 8.763f)
            lineTo(14.463f, 8.714f)
            lineTo(14.413f, 8.77f)
            close()
            moveTo(11.081f, 10.163f)
            lineTo(11.023f, 10.114f)
            lineTo(10.977f, 10.17f)
            lineTo(11.03f, 10.218f)
            lineTo(11.081f, 10.163f)
            close()
            moveTo(11.538f, 10.576f)
            lineTo(11.488f, 10.632f)
            lineTo(11.545f, 10.684f)
            lineTo(11.595f, 10.624f)
            lineTo(11.538f, 10.576f)
            close()
            moveTo(13.125f, 7.722f)
            lineTo(13.175f, 7.667f)
            lineTo(13.117f, 7.615f)
            lineTo(13.067f, 7.674f)
            lineTo(13.125f, 7.722f)
            close()
            moveTo(13.582f, 8.136f)
            lineTo(13.64f, 8.184f)
            lineTo(13.686f, 8.129f)
            lineTo(13.632f, 8.081f)
            lineTo(13.582f, 8.136f)
            close()
            moveTo(10.787f, 9.898f)
            lineTo(10.737f, 9.954f)
            lineTo(10.795f, 10.007f)
            lineTo(10.845f, 9.946f)
            lineTo(10.787f, 9.898f)
            close()
            moveTo(10.33f, 9.485f)
            lineTo(10.272f, 9.437f)
            lineTo(10.226f, 9.492f)
            lineTo(10.279f, 9.54f)
            lineTo(10.33f, 9.485f)
            close()
            moveTo(12.837f, 7.44f)
            lineTo(12.894f, 7.488f)
            lineTo(12.941f, 7.433f)
            lineTo(12.887f, 7.384f)
            lineTo(12.837f, 7.44f)
            close()
            moveTo(12.379f, 7.026f)
            lineTo(12.43f, 6.97f)
            lineTo(12.372f, 6.918f)
            lineTo(12.322f, 6.978f)
            lineTo(12.379f, 7.026f)
            close()
            moveTo(11.785f, 10.888f)
            lineTo(12.242f, 11.302f)
            lineTo(12.343f, 11.19f)
            lineTo(11.885f, 10.776f)
            lineTo(11.785f, 10.888f)
            close()
            moveTo(13.898f, 8.307f)
            lineTo(11.778f, 10.783f)
            lineTo(11.892f, 10.881f)
            lineTo(14.012f, 8.405f)
            lineTo(13.898f, 8.307f)
            close()
            moveTo(14.463f, 8.714f)
            lineTo(14.005f, 8.301f)
            lineTo(13.905f, 8.412f)
            lineTo(14.362f, 8.826f)
            lineTo(14.463f, 8.714f)
            close()
            moveTo(12.349f, 11.295f)
            lineTo(14.47f, 8.819f)
            lineTo(14.356f, 8.721f)
            lineTo(12.236f, 11.197f)
            lineTo(12.349f, 11.295f)
            close()
            moveTo(11.03f, 10.218f)
            lineTo(11.488f, 10.632f)
            lineTo(11.588f, 10.521f)
            lineTo(11.131f, 10.107f)
            lineTo(11.03f, 10.218f)
            close()
            moveTo(13.067f, 7.674f)
            lineTo(11.023f, 10.114f)
            lineTo(11.138f, 10.211f)
            lineTo(13.182f, 7.771f)
            lineTo(13.067f, 7.674f)
            close()
            moveTo(13.632f, 8.081f)
            lineTo(13.175f, 7.667f)
            lineTo(13.074f, 7.778f)
            lineTo(13.532f, 8.192f)
            lineTo(13.632f, 8.081f)
            close()
            moveTo(11.595f, 10.624f)
            lineTo(13.64f, 8.184f)
            lineTo(13.525f, 8.088f)
            lineTo(11.481f, 10.528f)
            lineTo(11.595f, 10.624f)
            close()
            moveTo(10.837f, 9.843f)
            lineTo(10.38f, 9.429f)
            lineTo(10.279f, 9.54f)
            lineTo(10.737f, 9.954f)
            lineTo(10.837f, 9.843f)
            close()
            moveTo(12.779f, 7.392f)
            lineTo(10.729f, 9.85f)
            lineTo(10.845f, 9.946f)
            lineTo(12.894f, 7.488f)
            lineTo(12.779f, 7.392f)
            close()
            moveTo(12.329f, 7.082f)
            lineTo(12.786f, 7.495f)
            lineTo(12.887f, 7.384f)
            lineTo(12.43f, 6.97f)
            lineTo(12.329f, 7.082f)
            close()
            moveTo(10.387f, 9.533f)
            lineTo(12.437f, 7.074f)
            lineTo(12.322f, 6.978f)
            lineTo(10.272f, 9.437f)
            lineTo(10.387f, 9.533f)
            close()
        }
    }.build()
}

@Preview
@Composable
private fun SouthKoreaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.SouthKorea,
            contentDescription = "South Korea Flag"
        )
    }
}
